import { useEffect, useState } from "react";
import { IDashboard } from "../../../../libs/types/dashboards";
import {
  ISocketReturn,
  TypeSockectEvent,
} from "../../../../libs/types/sockets";
import { useLoginContext } from "../context";
import DataFunctions from "../functions/database";
import DashboardsAPI from "../services/api/dashboards";
import { socket } from "../services/socket";

const room: TypeSockectEvent = "dashboard_update";

const useDashboardsSocket = () => {
  const [data, setData] = useState<IDashboard[]>([]);
  let auth = useLoginContext();

  useEffect(() => {
    getBase();
  }, []);

  useEffect(() => {
    if (socket && socket.connected) {
      socket.on(room, (io: ISocketReturn) => {
        //console.log(room, io);

        const ioData: IDashboard = io.data;
        const index = data.findIndex(
          (item) =>
            new DataFunctions().getId(item) ===
            new DataFunctions().getId(ioData)
        );

        var current_data: IDashboard[] = [...data];

        switch (io.socketReturn) {
          case "add":
            current_data.push(ioData);
            break;

          case "update":
            if (index > -1) current_data[index] = ioData;
            break;

          case "delete":
            current_data = data.filter(
              (item) =>
                new DataFunctions().getId(item) !==
                new DataFunctions().getId(ioData)
            );
            break;
        }

        setData(current_data);
      });
    }
  }, [socket, data]);

  const getBase = async () => {
    if (auth.loginDataContext.master) {
      new DashboardsAPI().list().then(async (res) => {
        if (res.success) await setData(res.data);
      });
    } else {
      new DashboardsAPI()
        .listByUser(auth.loginDataContext.id ? auth.loginDataContext.id : "")
        .then(async (res) => {
          if (res.success) await setData(res.data);
        });
    }
  };

  return data;
};

export default useDashboardsSocket;
